module.exports = __webpack_public_path__ + "static/media/pen.5b2c1df5.svg";